import CSS from './sidebar.module.css'

export const Sidebar = ({ children, backgroundColor }) => {
    return (
        <section className={CSS.layout} style={{ backgroundColor }}>
            { children }
        </section>
    )
}
